export default __webpack_public_path__ + "static/media/icon_endtype_ClosedEnds.38664b02.png";